import React, { useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { personalizeAction } from '../../../store/pesonalize-store';
import * as XLSX from "xlsx";
import { cuteToast } from '../../UI/cute';

const ImportContactsModal = ({activeTab,setShowcontactModal}) => {

    const [showDropzone, setShowDropzone] = useState(true);
    const [showUploadFiles, setShowUploadFiles] = useState(false);
    const [uploadFiles,setUploadFiles] = useState([]);
    const [showActiveTab,setShowActivetab] = useState(activeTab);

    const dispatch = useDispatch();

    const [inputFields,setInputFields] = useState([
        {
            email:"",
            fname:"",
            companyName:"",
            userLocation:"",
            error:""
        },
        {
            email:"",
            fname:"",
            companyName:"",
            userLocation:"",
            error:""
        },
        {
            email:"",
            fname:"",
            companyName:"",
            userLocation:"",
            error:""
        },
    ])
    
    const baseStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#000000'
    };

    function filesizeValidator(file) {
        if (file.size > 15728640) {
          return {
            code: "file-too-large",
            message: `File Size should not be more than ${formatBytes(15728640)}`
          };
        }
      
        return null
    }

    const processSheetData = (excelData) => {
        const wsname = excelData.SheetNames[0];
        const ws = excelData.Sheets[wsname];

        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 , blankrows: false}); 
        let csv = []; 
        let headers = []; 
        // console.log(dataParse.length)
        for (let i = 0; i < dataParse.length; i++) {   
            if (dataParse[i] === "") continue;   
            
            let fields = dataParse[i];   
            if (i === 0) {     
                headers = fields;   
            } else {     
                let csvRow = [];     
                for (let field of fields) {       
                    if (!isNaN(field)) field = Number(field);  
                    // console.log(field)     
                    csvRow.push(field);     
                }     
                csv.push(csvRow);  
            } 
        } 

        var cloneFields = [];
        csv.map( (data) =>{
            
            var obj = {
                email:data[0],
                fname:data[1],
                companyName:data[3],
                userLocation:data[4]
            }

            cloneFields.push(obj);
            return true;
        })

        cuteToast({
            type: "success",
            message: `${cloneFields.length} contacts imported successfully`,
            timer: 5000,
            title: "",
        });
        // setHeaders(headers); 
        // setRows(csv);
        dispatch(
            personalizeAction.setEmailContacts({
                personalize_emailContacts: cloneFields,
            })
        );
        console.log(headers)
    };

    const {
        getRootProps: getRootFirstProps,
        getInputProps: getInputFirstProps,
        isFocused,
        isDragAccept,
        isDragReject,
        fileRejections,
        acceptedFiles
    } = useDropzone({
        accept: '.csv,.xls,.xlsx,application/vnd.ms-excel, text/csv',
        maxFiles: 1,
        validator: filesizeValidator
    });

    useEffect(()=>{
        if(acceptedFiles  && acceptedFiles.length > 0){
            setShowDropzone(false)
            setShowUploadFiles(true)
            setUploadFiles(acceptedFiles); 
        }    
    },[acceptedFiles])

    const fileRejectionItems = fileRejections.map(({ file, errors }) => (
        <div key={file.path}>
            {file.path} - {file.size} bytes
            <div className="d-inline-flex text-danger ms-sm-3">
                {errors.map(e => (
                    <span key={e.code}>{e.message}</span>
                ))}
            </div>
        </div>
    ));

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes';
    
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    
        const i = Math.floor(Math.log(bytes) / Math.log(k));
    
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }


    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    const handleCancel = (event) =>{
        event.preventDefault();
        // setSelectFile('');
        setUploadFiles([]);
        setShowDropzone(true)
        setShowUploadFiles(false)
        setShowcontactModal(false)
    }

    const handleProcess = (event,type) =>{
        event.preventDefault();
        if(type === 'manual'){
            // console.log(inputFields.filter( fields=>fields.error).length);
            if(inputFields.filter( fields=>fields.error).length > 0){
                cuteToast({
                    type: "error",
                    message: `Please check entered email!`,
                    timer: 3000,
                    title: "Invalid Email",
                });
                setShowcontactModal(true)
            }else{
                const inputFieldsData = inputFields.filter( fields=>fields.email !== '');
                // console.log(inputFieldsData)
                cuteToast({
                    type: "success",
                    message: `${inputFieldsData.length} contacts added successfully`,
                    timer: 3000,
                    title: "",
                });
                dispatch(
                    personalizeAction.setEmailContacts({
                        personalize_emailContacts: inputFields,
                    })
                );

                setShowcontactModal(false)
            }
        }

        if(type === 'csv'){
            const reader = new FileReader();
            let file = acceptedFiles[0];
            reader.onload = function (e) {
                const data = e.target.result;
                let readedData = XLSX.read(data, { type: "binary" });
                processSheetData(readedData); 
            }; 
            reader.readAsBinaryString(file);

            setShowcontactModal(false)
        }

        
    }

    const handleAddContact = (event) =>{
        event.preventDefault();
        
        const newArr = {
            email:"",
            fname:"",
            companyName:"",
            userLocation:"",
            error:""
        }

        setInputFields([...inputFields,newArr])
    }

    const isValidEmail = email =>
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
    );

    const handleChange = (e,index,type) =>{
        // console.log(index,type)
        var clone = [...inputFields]

        const isValid = isValidEmail(e.target.value);

        var obj = clone[index];

        if(type === 'email'){
            if(isValid){
                obj["error"] = false 
            }else{
                obj["error"] = true  
            }
        }
        obj[type] = e.target.value
        clone[index]= obj; 
        setInputFields(clone)
    }
    

    return (
        <div className={`modal popup1 ${activeTab ? 'd-block fade show':''}`} id="importContacts" style={{background: "#000000ba"}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Import Contacts</h5>
                            <button
                                type="button"
                                className="close_btn"
                                style={{ position: 'inherit' }}
                                onClick={handleCancel}
                            ><i className="fa fa-close"></i></button>
                        </div>
                        <div className="modal-body navpill_section p-4">
                            <nav>
                                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                    <button 
                                        className={`nav-link ${(showActiveTab === 'local') && 'active'}`} 
                                        id="nav-local-tab" 
                                        // data-bs-toggle="tab" 
                                        // data-bs-target="#nav-local" 
                                        type="button" 
                                        role="tab" 
                                        // aria-controls="nav-local" 
                                        // aria-selected="true"
                                        onClick={(e)=>setShowActivetab('local')}
                                    >Local</button>
                                    <button 
                                        className={`nav-link ${(showActiveTab === 'add') && 'active'}`} 
                                        id="nav-libraryimages-tab" 
                                        // data-bs-toggle="tab" 
                                        // data-bs-target="#nav-libraryimages" 
                                        type="button" 
                                        role="tab" 
                                        onClick={(e)=>setShowActivetab('add')}
                                        // aria-controls="nav-libraryimages" 
                                        // aria-selected="false"
                                    >Add Contact</button>
                                </div>
                            </nav>
                            <div className="tab-content p-4 pb-0" id="nav-tabContent">
                                <div className={`tab-pane fade ${(showActiveTab === 'local') && 'show active'}`} id="nav-local" role="tabpanel" aria-labelledby="nav-local-tab">
                                    <div className="v_c_import">

                                        {showDropzone && (
                                            <>
                                                <div className="image-upload" {...getRootFirstProps({ style })}>
                                                    <label style={{ cursor: "pointer" }} htmlFor="file_upload">
                                                        <div className="h-100">
                                                            <div className="dplay-tbl">
                                                                <div className="dplay-tbl-cell">
                                                                    <i><img src={process.env.PUBLIC_URL + "/assets/images/upload.png"} className="img-fluid" alt="img" /></i>
                                                                    <input {...getInputFirstProps()} />
                                                                    <h6 className="pt-2 m-0">Click to select a file Or Drag & drop your file here</h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </label>
                                                </div>
                                                <div className='my-2'>{fileRejectionItems}</div>
                                            </>
                                        )}

                                        { showUploadFiles && (
                                            uploadFiles.map((file)=>(
                                                <div className='acceptFiles' key={file.name.slice(0, file.name.lastIndexOf("."))}>
                                                   
                                                    <div className="form-group row">
                                                        <label htmlFor="staticEmail" className="col-sm-2 col-form-label">Selected File</label>
                                                        <div className="col-sm-10">
                                                            <input 
                                                                type="text" 
                                                                readOnly 
                                                                className="form-control-plaintext" 
                                                                id="staticEmail" 
                                                                defaultValue={file.name} 
                                                                style={{outline: "none"}}
                                                            />
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                            ))
                                        )}

                                        <div className="note_rw pt-2 pb-3">
                                            <span className="pink_clor">NOTE:</span> Supports only XLS, XLSX, CSV formats with a maximum file size of 5 MB
                                            <a href="https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/PersonalizationContacts.csv" className='ms-4 border-0'>Download Sample File</a>
                                        </div>
                                        <div className="btn_wrap_p text-end">
                                            <button className="btn btn2 me-2" onClick={handleCancel}>Cancel</button>
                                            <button className="btn btn1" onClick={(e)=>handleProcess(e,'csv')}>Proceed</button>
                                        </div>
                                    </div>
                                </div>

                                <div className={`tab-pane fade ${(showActiveTab === 'add') && 'show active'}`} id="nav-libraryimages" role="tabpanel" aria-labelledby="nav-libraryimages-tab">
                                    <div className="recordedvideo">
                                        <div className="row">
                                            <div className="col-md-12 mb-4">
                                                {inputFields && inputFields.map((row,index)=>(
                                                    <div className='row' key={index}>
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className={`form-control ${row.error ? "is-invalid" : ""}`}
                                                                    placeholder='Email'
                                                                    onChange={(e)=>handleChange(e,index,'email')}
                                                                    value={row.email}
                                                                />
                                                                {row.error && (
                                                                    <div className="invalid-feedback">
                                                                        Please Enter Valid Email!.
                                                                    </div>
                                                                )}
                                                                
                                                            </div>
                                                        </div>
                                                       
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className="form-control"
                                                                    placeholder='First Name'
                                                                    value={row.fname} 
                                                                    onChange={(e)=>handleChange(e,index,'fname')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className="form-control"
                                                                    placeholder='Company Name' 
                                                                    value={row.companyName}
                                                                    onChange={(e)=>handleChange(e,index,'companyName')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <div className="rv_col mb-4">
                                                                <input 
                                                                    className="form-control"
                                                                    placeholder='Location' 
                                                                    value={row.userLocation}
                                                                    onChange={(e)=>handleChange(e,index,'userLocation')}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                
                                                <div className='row'>
                                                    <div className="col-md-3 col-6">
                                                        <div className="rv_col mb-4">
                                                            <button className='btn bg-secondary' onClick={handleAddContact}>Add New Contact</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="iv_footer">
                                            <div className="btn_wrap_p text-end">
                                                <button className="btn btn2 me-2" onClick={handleCancel}>Cancel</button>
                                                <button className="btn btn1" onClick={(e)=>handleProcess(e,'manual')}>Proceed</button></div>
                                        </div>

                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>
        </div>
    )
}

export default ImportContactsModal